import { BlueVerification, GreenVerification } from "assets/icons";

export const profileVerification = (key) => {
  switch (key) {
    case 1:
      return <BlueVerification />;
    case 2:
      return <GreenVerification />;
    case 3:
      return (
        <>
          <BlueVerification />
          <GreenVerification />
        </>
      );
    default:
      return null;
  }
};
